// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"160":"756da9b8","324":"756da9b8","713":"fde51fb4","767":"2731a0e8"}[chunkId] + ".chunk.css";
};